module.exports = __webpack_public_path__ + "img/Louis trio, la belle affaire.65592c53.png";